import {CalendarDate} from '@internationalized/date';
import {ZURICH_TIMEZONE} from 'constants/date';
import {formatDateInZurichTZ} from 'helpers/dates';
import {format, parse} from 'date-fns';

export class AmnisDate {
    static apiRequestDateFormat = 'yyyy-MM-dd';
    static apiRequestDateTimeFormat = "yyyy-MM-dd'T'HH:mm:ssXXX";
    static displayDateFormat = 'dd.MM.yyyy';
    static zurichTZ = 'Europe/Zurich';

    static parseDate(dateObj: Date | null): CalendarDate | null {
        if (!dateObj) return null;
        return new CalendarDate(
            dateObj.getFullYear(),
            dateObj.getMonth() + 1,
            dateObj.getDate(),
        );
    }

    static parseDateString(dateString: string | null, dateFormat: string) {
        if (!dateString) return null;
        return this.parseDate(parse(dateString, dateFormat, new Date()));
    }

    static toDate(calendarDate: CalendarDate): Date {
        return calendarDate.toDate(this.zurichTZ);
    }

    static formatApiDateToDisplayDate(
        apiDate?: string,
        _format: string = this.displayDateFormat,
        locale?: Locale,
    ) {
        if (!apiDate || typeof apiDate !== 'string') return apiDate;
        return format(
            parse(
                apiDate,
                apiDate.includes('T')
                    ? this.apiRequestDateTimeFormat
                    : this.apiRequestDateFormat,
                new Date(),
            ),
            _format,
            {locale},
        );
    }

    static formatDateToApiDate(date: Date) {
        if (!date || !(date instanceof Date)) {
            throw new Error(`Invalid date: ${date}`);
        }

        return format(date, this.apiRequestDateFormat);
    }

    static formatDateToDisplayDate(date: Date) {
        if (!date || !(date instanceof Date)) {
            throw new Error(`Invalid date: ${date}`);
        }

        return format(date, this.displayDateFormat);
    }

    static formatCalendarDateToApi(
        calendarDate: CalendarDate | null | undefined,
        time?: 'start' | 'end',
    ) {
        const timeValue = this.getTimeValue(time);
        return calendarDate
            ? `${formatDateInZurichTZ(calendarDate.toDate(ZURICH_TIMEZONE))} ${timeValue}`
            : null;
    }

    private static getTimeValue(time?: 'start' | 'end') {
        switch (time) {
            case 'end':
                return '23:59:59';
            case 'start':
                return '00:00:00';
            default:
                return '';
        }
    }
}
